import { render, staticRenderFns } from "./segment-header.vue?vue&type=template&id=c818bc0e"
import script from "./segment-header.vue?vue&type=script&lang=js"
export * from "./segment-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports